export const stackNumberOfCards = new Map();
export const stackTitles = new Map();
export const stackPrefix ="https://leelaonline-metaphoric-cards.s3.eu-north-1.amazonaws.com/"
export const fileExtension =".jpg"
export const stack1Title = "https://leelaonline-metaphoric-cards.s3.eu-north-1.amazonaws.com/1/0.jpg"
export const stack2Title = "https://leelaonline-metaphoric-cards.s3.eu-north-1.amazonaws.com/5/0.jpg"
export const stack3Title = "https://leelaonline-metaphoric-cards.s3.eu-north-1.amazonaws.com/3/0.jpg"

stackNumberOfCards.set(1, 60);
stackNumberOfCards.set(2, 50);
stackNumberOfCards.set(3, 58);

stackTitles.set(1, stack1Title);
stackTitles.set(2, stack2Title);
stackTitles.set(3, stack3Title);